import { gameState } from "appworks/model/game-state";
import { Exit } from "appworks/state-machine/data/exit";
import { Decision } from "appworks/state-machine/decisions/decision";

export class ShouldExitFreespinsDecision extends Decision {
    public evaluate() {
        const gameplay = gameState.getCurrentGame();

        return gameplay.areFreespinsPending() ? Exit.False : Exit.True;
    }
}
